export default "/_next/static/images/bb1d3f8010c0ec07ed8599d1f4d00585.svg";